import { apiClient } from "./client";

const groupsApi = {
  list: () => apiClient("/groups", { method: "GET" }),
  get: (id) => apiClient(`/groups/${id}`, { method: "GET" }),
  create: ({ name, description, visibility }) =>
    apiClient("/groups", { method: "POST", body: { name, description, visibility } }),
  remove: (id) => apiClient(`/groups/${id}`, { method: "DELETE" }),

  listMembers: (id) => apiClient(`/groups/${id}/members`, { method: "GET" }),
  changeRole: (id, userId, role) =>
    apiClient(`/groups/${id}/members/${userId}`, { method: "PATCH", body: { role } }),
  removeMember: (id, userId) =>
    apiClient(`/groups/${id}/members/${userId}`, { method: "DELETE" }),
  leave: (id) => apiClient(`/groups/${id}/members/me`, { method: "DELETE" }),

  requestJoin: (id) => apiClient(`/groups/${id}/join-requests`, { method: "POST" }),
  listJoinRequests: (id) => apiClient(`/groups/${id}/join-requests`, { method: "GET" }),
  resolveJoinRequest: (id, reqId, decision) =>
    apiClient(`/groups/${id}/join-requests/${reqId}/${decision}`, { method: "POST" }),

  invite: (id, email) =>
    apiClient(`/groups/${id}/invitations`, { method: "POST", body: { email } }),

  listMyInvitations: () =>
    apiClient("/invitations-groups/me/invitations", { method: "GET" }),
  resolveInvitation: (reqId, decision) =>
    apiClient(`/invitations-groups/me/invitations/${reqId}/${decision}`, { method: "POST" }),

  listGroupInvitations: (id) => apiClient(`/groups/${id}/invitations`, { method: "GET" }),
  revokeInvitation: (id, reqId) =>
    apiClient(`/groups/${id}/invitations/${reqId}`, { method: "DELETE" }),
};

export default groupsApi;
